import { COUNTRIES_CONFIG } from '../../config/countriesEnvironments';

const { countryCode } = COUNTRIES_CONFIG;
let sampleCsvData = [];

if (countryCode === 'SAU') {
  sampleCsvData = [
    {
      commercialRegistration: '',
      freelancerNumber: '',
      iban: 'SA2810000011100000461309',
      nationalId: '1106972886',
      type: 'PERSONAL',
      unifiedNumber: '',
    },
    {
      commercialRegistration: '',
      freelancerNumber: 'FL-67846766',
      iban: 'SA2810000011100000461309',
      nationalId: '1046403927',
      type: 'FREELANCER',
      unifiedNumber: '',
    },
    {
      commercialRegistration: '1010093978',
      freelancerNumber: '',
      iban: 'SA2810000011100000461309',
      nationalId: '',
      type: 'BUSINESS',
      unifiedNumber: '7000000000',
    },
  ];
} else {
  sampleCsvData = [
    {
      fullName: 'ADAM AHMED',
      iban: 'AE620030012285049920001',
      emiratesId: '',
      tradeLicence: '',
      type: 'PERSONAL',
    },
    {
      fullName: 'Adam something',
      iban: 'AE620030012285049920001',
      emiratesId: '',
      tradeLicence: '',
      type: 'PERSONAL',
    },
    {
      fullName: '',
      iban: 'AE620030012285049920001',
      emiratesId: '784-1967-10121542',
      tradeLicence: '',
      type: 'PERSONAL',
    },
    {
      fullName: '',
      iban: 'AE620030012285049920001',
      emiratesId: '',
      tradeLicence: 'CL4206',
      type: 'BUSINESS',
    },
    {
      fullName: 'ABC Limited',
      iban: 'AE620030012285049920001',
      emiratesId: '',
      tradeLicence: '',
      type: 'BUSINESS',
    },
    {
      fullName: 'ABC something',
      iban: 'AE620030012285049920001',
      emiratesId: '',
      tradeLicence: '',
      type: 'BUSINESS',
    },
  ];
}

const sampleCsvFile = {
  fileName: `iban-verification-bulk-upload-${countryCode}.csv`.toLowerCase(),
  sampleCsvData,
};

export { sampleCsvFile };
